import { useQuery } from "@tanstack/react-query";
import { StatsService } from "../../services";
import { asQuery } from "../../services/common";
import { BID_STATUS } from "../../utils/enums";
import { DASH_STALE } from "./shared";

export function useBuyerCounts(token?: string) {
  return useQuery({
    queryKey: ["stats", "buyer-counts", token],
    queryFn: () => asQuery<any>(StatsService.getBuyerCounts(token as string)),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}

export function useSellerCounts(token?: string) {
  return useQuery({
    queryKey: ["stats", "seller-counts", token],
    queryFn: () => asQuery<any>(StatsService.getSellerCounts(token as string)),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}

// Buyer's yearly bids needs two series (all + winning) for the grouped bars.
export function useBuyerBidsYearly(token?: string, year?: number) {
  return useQuery({
    queryKey: ["stats", "buyer-bids-yearly", token, year],
    queryFn: async () => {
      const [all, win] = await Promise.all([
        asQuery<any[]>(
          StatsService.getBuyerBidsYearly(token as string, {
            year,
            status: BID_STATUS.ALL,
          }),
        ),
        asQuery<any[]>(
          StatsService.getBuyerBidsYearly(token as string, {
            year,
            status: BID_STATUS.WIN,
          }),
        ),
      ]);
      return { all, win };
    },
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}

export function useSellerBidsYearly(token?: string, year?: number) {
  return useQuery({
    queryKey: ["stats", "seller-bids-yearly", token, year],
    queryFn: () =>
      asQuery<any[]>(StatsService.getSellerBidsYearly(token as string, { year })),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}

export function useSellerSalesYearly(token?: string, year?: number) {
  return useQuery({
    queryKey: ["stats", "seller-sales-yearly", token, year],
    queryFn: () =>
      asQuery<any[]>(
        StatsService.getSellerSalesYearly(token as string, { year }),
      ),
    enabled: !!token,
    staleTime: DASH_STALE,
  });
}
